import { render } from "./Linje.vue?vue&type=template&id=3bf5ba82"
import script from "./Linje.vue?vue&type=script&lang=js"
export * from "./Linje.vue?vue&type=script&lang=js"

import exportComponent from "/Users/williamsandstrom/repos/web/ytopi/ytopi-configurator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__